import VueTypes, { nullable } from 'vue-types';

const SubcategoryShowcaseItem = VueTypes.shape({
    title: VueTypes.oneOfType([String, null]).isRequired,
    url: VueTypes.oneOfType([String, null]).isRequired,
    subcategories: VueTypes.arrayOf(VueTypes.any).isRequired
}).isRequired;

SubcategoryShowcaseItem.subcategories = VueTypes.arrayOf(SubcategoryShowcaseItem);

export const CategoryShowcaseItem = VueTypes.shape({
    mainTitle: VueTypes.oneOfType([String, nullable]).isRequired,
    mainImage: VueTypes.oneOfType([String, nullable]).isRequired,
    mainUrl: VueTypes.oneOfType([String, nullable]).isRequired
}).isRequired;

export const createSubCategoryShowcaseItem = ({ title, url, subcategories = [] }) => {
    return {
        title: title,
        url: url,
        subcategories: subcategories
    };
};

export const createCategoryShowcaseItem = ({ mainTitle, mainImage, mainUrl, subcategories = [] }) => {
    return {
        mainTitle: mainTitle,
        mainImage: mainImage,
        mainUrl: mainUrl
    };
};
